import type { Api, ReqBefore, ReqAfter, Method } from '@el-plus/utils/http'
import type { PropType, SetupContext, MaybeRef, ExtractPropTypes } from 'vue'
import { useAttrs } from 'vue'
export const apiProps = {
  api: {
    type: [String, Function] as PropType<Api>,
  },
  method: {
    type: String as PropType<Method>,
  },
  reqData: {
    type: Object,
  },
  reqParams: {
    type: Object,
  },
  reqBefore: {
    type: Function as PropType<ReqBefore>,
  },
  reqAfter: {
    type: Function as PropType<ReqAfter>,
  },
}
type IVisible = boolean | ((T: unknown) => boolean)
export const visibleProps = {
  show: {
    type: [Boolean, Function] as PropType<IVisible>,
  },
  hide: {
    type: [Boolean, Function] as PropType<IVisible>,
  },
}
export type VisibleProps = ExtractPropTypes<typeof visibleProps>
export const prepareProps = <T extends Record<string, any>>( // eslint-disable-line @typescript-eslint/no-explicit-any
  props: T,
  excludeKeys: string[] = [],
): Partial<T> => {
  return Object.keys(props).reduce((acc, key) => {
    if (!excludeKeys.includes(key)) {
      acc[key as keyof T] = props[key]
    }
    return acc
  }, {} as Partial<T>)
}

export type IDisabled = boolean | ((...args: any[]) => boolean)
export const disabledProps = {
  disabled: {
    type: [Boolean, Function] as PropType<IDisabled>,
  },
}
export type DisabledProps = ExtractPropTypes<typeof disabledProps>
export const prepareEvents = <T extends Record<string, unknown> | string[]>(
  emit: SetupContext<T>['emit'],
  eventKeys: string[],
  // (keyof T & string)[] = [],
) => {
  return eventKeys.reduce(
    (acc, key) => {
      // 转换on+事件名
      let eventName
      if (key.startsWith('on')) {
        eventName = key
      } else {
        if (key.includes('-')) {
          eventName =
            'on' +
            key
              .split('-')
              .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
              .join('')
        } else {
          eventName = `on${key.charAt(0).toUpperCase()}${key.slice(1)}`
        }
      }
      acc[eventName] = (...args: unknown[]) => emit(key, ...args)
      return acc
    },
    {} as Record<string, unknown>,
  )
}

export const prepareClassNames = () => {
  return useAttrs().class || ''
}
export const prepareStyles = () => {
  return useAttrs().style || {}
}
